import styled from "@material-ui/core/styles/styled";
import {TextField} from "formik-material-ui";

export const AppTextField = styled(TextField)({
  '& > .MuiInput-formControl:not(.Mui-error)': {
    marginBottom: '22px'
  }
});
